<script>

	import './style.scss'

	export default {
		name: 'navigation',
    data: () => ({
      showBanner: false,
    })
	}

</script>

<template>
  <div>
    <div class='banner' v-if="showBanner">
      <div />
      <div class='content'>
        <p>🎉 Master algorithms together on <a href="https://binarysearch.io/?ref=dcp" target="_blank">Binary Search</a>! Create a room, invite your friends, and race to finish the problems.</p>
      </div>
      <div class='close' @click="showBanner = false">
        <i class='ion-close' />
      </div>
    </div>
    <div class='nav'>
      <div class='nav-container'>
        <div class='logo'>
          <a href='/' class='icon'>
            <img src='~@/assets/svg/logo-small.svg'>
          </a>
          <a href='/'>
            <div class='text'>
              Daily Coding Problem
            </div>
          </a>
        </div>
        <ul class='links'>
          <li><a href='/blog'>Blog</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/Navigation/Navigation.vue